<div class="relative min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 overflow-hidden">
  <div
    class="absolute top-[-10%] left-[-5%] w-[500px] h-[500px] bg-indigo-500/10 rounded-full blur-3xl pointer-events-none"></div>
  <div
    class="absolute bottom-[-10%] right-[-5%] w-[500px] h-[500px] bg-purple-500/10 rounded-full blur-3xl pointer-events-none"></div>

  <div class="relative sm:mx-auto sm:w-full sm:max-w-md text-center z-10 mb-8">
    <div class="flex justify-center mb-6">
      <nem-logo [width]="220"></nem-logo>
    </div>
    <h2 class="text-3xl font-extrabold text-slate-900 tracking-tight">Welcome back</h2>
    <p class="mt-2 text-sm text-slate-500 font-medium">Sign in to access the V-NEM dashboard</p>
  </div>

  <div class="relative sm:mx-auto sm:w-full sm:max-w-md z-10">
    <div class="amplify-theme-override">
      <amplify-authenticator
        [formFields]="formFields"
        [services]="services"
        [loginMechanisms]="['email']"
        [signUpAttributes]="['name', 'given_name']">
        <ng-template amplifySlot="sign-up-form-fields" let-validationErrors="validationErrors">
          <amplify-sign-up-form-fields></amplify-sign-up-form-fields>

          <div class="mt-4 p-4 bg-slate-50 rounded-lg border border-slate-100">
            <amplify-checkbox
              [errorMessage]="validationErrors['acknowledgement']"
              [hasError]="!!validationErrors['acknowledgement']"
              name="acknowledgement"
              value="yes">
              <span class="text-sm text-slate-600"
                >I agree with the
                <a
                  class="text-indigo-600 font-semibold hover:text-indigo-700 hover:underline transition-colors"
                  (click)="openTerms()"
                  href="javascript:void(0)">
                  Terms & Conditions
                </a>
              </span>
            </amplify-checkbox>
          </div>
        </ng-template>
      </amplify-authenticator>
    </div>
  </div>
</div>
